module.exports = __webpack_public_path__ + "media/images/brand-hero-mobile-aca6084e9c3add012a5555263958d234.svg";